function errorText(error: unknown): string {
  if (typeof error === "string") return error;
  if (error && typeof error === "object" && "message" in error) {
    const message = (error as { message: unknown }).message;
    if (typeof message === "string") return message;
    if (message != null) return String(message);
  }
  return "";
}

/** Map provider errors to a translation key. Never return raw API text. */
export function getAuthErrorKey(error: unknown): string {
  const text = errorText(error).trim().toLowerCase();

  if (
    text.includes("already registered") ||
    text.includes("already been registered") ||
    text.includes("user already")
  ) {
    return "crm.auth.signup.email_taken";
  }

  if (
    !text ||
    text.includes("unauthorized") ||
    text.includes("invalid login") ||
    text.includes("invalid credentials") ||
    text.includes("invalid_grant") ||
    text.includes("invalid email or password")
  ) {
    return "crm.auth.invalid_credentials";
  }

  return "crm.auth.generic_error";
}
